import { ContentGroup, Grid, GridItem, Text } from '@imported/constellation';
import React from 'react';
import { useIdvProvider } from '../../context/index.js';
import { useLabelContext } from '../../context/LabelContext.js';
import { TAGGING_FIELDS } from '../../tagging/index.js';
import { CaptureDocumentWrapper, CapturePhotoImageWrapper, } from '../CapturePhotoForm/styles.js';
import { CONFIRM_CHECKBOX } from '../FormFields/fieldNames.js';
import { ConfirmationWrapper, VerticalSpace } from '../FormFields/index.js';
import Navigation from '../Navigation/index.js';
const checkboxLabel = (getLabelFromContext) => (React.createElement(Text, { size: 's2' }, getLabelFromContext('components.selfiePhotoForm.confirmation.heading')));
const CaptureSelfiePhotoForm = ({ isLoading, handleCapturePhotoSubmission, handlePreviousPage, continueFlag, control, errors, }) => {
    const { idvState } = useIdvProvider();
    const { captureSelfieResponse: result } = idvState;
    const { getLabelFromContext } = useLabelContext();
    return (React.createElement(CaptureDocumentWrapper, null,
        React.createElement(Grid, null,
            React.createElement(GridItem, null,
                React.createElement(ContentGroup, null,
                    React.createElement(CapturePhotoImageWrapper, null,
                        React.createElement("img", { alt: 'capture photo', src: result?.response?.failedImage
                                ? result?.response?.failedImage
                                : result?.response?.imageData })),
                    React.createElement(VerticalSpace, { space: 40 }),
                    !continueFlag && (React.createElement(ConfirmationWrapper, { checkboxProps: {
                            label: checkboxLabel(getLabelFromContext),
                            error: errors[CONFIRM_CHECKBOX]?.message,
                            name: CONFIRM_CHECKBOX,
                            marginBottom: '07',
                            taggingLabel: TAGGING_FIELDS.CONFIRM_CHECKBOX_SELFIE,
                            captureInput: true,
                        }, control: control, name: CONFIRM_CHECKBOX })),
                    React.createElement(Navigation, { continueFlag: continueFlag, previousLabel: getLabelFromContext('components.selfiePhotoForm.navigation.previous'), submitLabel: getLabelFromContext('components.selfiePhotoForm.navigation.next'), submitLoading: isLoading, handleNext: handleCapturePhotoSubmission, handlePrevious: handlePreviousPage }))))));
};
export default CaptureSelfiePhotoForm;
//# sourceMappingURL=index.js.map